module.exports = __webpack_public_path__ + "static/img/4594_phase_function_Paper_Points.025fef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4594_phase_function_Paper_Points.png
// module id = Ra4M
// module chunks = 0